/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { ajax } from '@src/common/ajax';
import { Result, SelectOption } from '@src/common/types';
import { ApiUrl } from '@src/common/ajax/apiUrl';
import { getResultStatus } from '@src/common/util/getResultStatus';
import { FraudType, FraudTypeResponse } from '../types';

export async function raFetchFilters(): Promise<Result<SelectOption[]>> {
  const {
    success,
    payload: { content },
  } = await ajax<FraudTypeResponse>(
    { content: [] },
    ApiUrl.riskScoreFraudTypes,
    { method: 'get' }
  );

  const result: SelectOption[] = sanitizeEventTypesResponse(content);
  const resultStatus = getResultStatus(success, result);

  return {
    result,
    resultStatus,
  };
}

function sanitizeEventTypesResponse(content: FraudType[]): SelectOption[] {
  let items = Array.isArray(content) ? [...content] : [];
  items = items.filter((item) => !!item);
  return items.map((item) => {
    return {
      value: item.code ?? '',
      label: item.displayName ?? '',
    };
  });
}
